import { render, staticRenderFns } from "./createNews.vue?vue&type=template&id=20d71a15&scoped=true&"
import script from "./createNews.vue?vue&type=script&lang=js&"
export * from "./createNews.vue?vue&type=script&lang=js&"
import style0 from "./createNews.vue?vue&type=style&index=0&id=20d71a15&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d71a15",
  null
  
)

export default component.exports